import React, { useEffect, useState } from "react";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {intersection} from 'underscore';
import {
  useParams,
} from "react-router-dom";
import {Button, Col, Form, Row, Image, Modal} from 'react-bootstrap';
//import { MDBRipple } from 'mdb-react-ui-kit';
import './pdfitem.css'; 
import { useNavigate } from "react-router-dom";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import ClipLoader from "react-spinners/ClipLoader";
import {RedButton} from '../components/MyButton';

import ItemHomework from '../components/ItemHomework';


export default function Pdfitem() {
	let params = useParams();
  let itemId = params.itemId;
	
  const [updateClickedF, setUpdateClickedF] = useState(false);
  const [updateClickedS2F, setUpdateClickedS2F] = useState(false);
  const [updateClickedS3F, setUpdateClickedS3F] = useState(false);
	
  const [message, setMessage] = useState("");
	
	const [name, setName] = useState('');
	
	const [classCode, setClassCode] = useState('');
	const [rcSubject, setRcSubject] = useState('english');
	const [itemIds, setItemIds] = useState([]);
	const [json, setJson] = useState('');
	const [categoryTags, setCategoryTags] = useState([]);
	const [tags, setTags] = useState([]);
	const [pdfs, setPdfs] = useState([]);
	const [syllabusIds, setSyllabusIds] = useState([]);
	
	const [pdfsLastUpdateTs, setPdfsLastUpdateTs] = useState('');
	const [jsonUpdateTs, setJsonUpdateTs] = useState('');
	
	
	
	const [categoryTagsAllOption, setCategoryTagsAllOption] = useState([]);
	const [tagsAllOption, setTagsAllOption] = useState([]);
	const [syllabusesAllOption, setSyllabusesAllOption] = useState([]);
	
	const [nameRaw, setNameRaw] = useState('');
	const [classCodeRaw, setClassCodeRaw] = useState('');
	const [rcSubjectRaw, setRcSubjectRaw] = useState('english');
	const [itemIdsRaw, setItemIdsRaw] = useState([]);
	const [jsonRaw, setJsonRaw] = useState('');
	const [categoryTagsRaw, setCategoryTagsRaw] = useState([]);
	const [tagsRaw, setTagsRaw] = useState([]);
	//const [pdfsRaw, setPdfsRaw] = useState([]);
	const [syllabusIdsRaw, setSyllabusIdsRaw] = useState([]);
	
	const [nameF, setNameF] = useState(false);
	const [classCodeF, setClassCodeF] = useState(false);
	const [rcSubjectF, setRcSubjectF] = useState(false);
	const [itemIdsF, setItemIdsF] = useState(false);
	const [jsonF, setJsonF] = useState(false);
	const [categoryTagsF, setCategoryTagsF] = useState(false);
	const [tagsF, setTagsF] = useState(false);
	//const [pdfsF, setPdfsF] = useState(false);
	const [syllabusIdsF, setSyllabusIdsF] = useState(false);
	
	const [extraLessonType, setExtraLessonType] = useState('PDF');
	const [extraLessonTypeRaw, setExtraLessonTypeRaw] = useState('PDF');
	const [extraLessonTypeF, setExtraLessonTypeF] = useState(false);
	
	
	const [writingTitle, setWritingTitle] = useState('');
	const [writingTitleRaw, setWritingTitleRaw] = useState('');
	const [writingTitleF, setWritingTitleF] = useState(false);

	const [writingInstruction, setWritingInstruction] = useState('');
	const [writingInstructionRaw, setWritingInstructionRaw] = useState('');
	const [writingInstructionF, setWritingInstructionF ]= useState(false);
	
	const [writingAttachment, setWritingAttachment] = useState([]);
	
	const [allChineseWritingComments, setAllChineseWritingComments] = useState([]);
	
	const [chineseWritingComment, setChineseWritingComment] = useState(
		{
			rawCommentId:1,
			commentId:1,
		}
	);
	
	const navigate = useNavigate();
	
	/*const enableUpdate=()=> {
    return nameF || classCodeF || rcSubjectF || itemIdsF || jsonF || categoryTagsF || tagsF;
	}*/
	
	
	useEffect(() => {
		getData('item/courseItem?itemId=' + itemId, navigate)
		.then(res => {			
				let tmpName = res.data.name;
				let tmpClassCode = res.data.classCode;
				let tmpRcSubject = res.data.rcSubject;
				
				let tmpExtraLessonType = res.data.extraLessonType;
				setExtraLessonType(tmpExtraLessonType);
				setExtraLessonTypeRaw(tmpExtraLessonType);
				
				setThumbnailPath(p=>({...p, data:res.data.thumbnailPath}));
				//console.log(res.data.extraInformation);
				let tmpWritingTitle = (res.data.extraInformation) ? res.data.extraInformation.writingTitle : "";
				setWritingTitle(tmpWritingTitle);
				setWritingTitleRaw(tmpWritingTitle);
				
				let tmpWritingInstruction = (res.data.extraInformation) ? res.data.extraInformation.writingInstruction : "";
				setWritingInstruction(tmpWritingInstruction);
				setWritingInstructionRaw(tmpWritingInstruction);
				
				let tmpWritingAttachment = (res.data.extraInformation) ? (res.data.extraInformation.writingAttachment) : [];
				setWritingAttachment(tmpWritingAttachment);

				let tmpItemIds = (res.data.itemIds) ? res.data.itemIds : [];
				let tmpJson = (res.data.json) ? res.data.json : "";
				let tmpCategoryTags = (res.data.categoryTags) ? res.data.categoryTags : [];
				let tmpTags = (res.data.tags) ? res.data.tags : [];
				let tmpPdfs = res.data.pdfs;
				let tmpSyllabusIds = res.data.syllabusIds;
		
				let tmpPdfsLastUpdateTs = res.data.pdfsLastUpdateTs;
				let tmpJsonUpdateTs = res.data.jsonUpdateTs;
				setAllChineseWritingComments(res.data.allChineseWritingComments);
				
				setChineseWritingComment((prev)=>({...prev, ['rawCommentId']:res.data.commentId, ['commentId']:res.data.commentId}))
				
				setName(tmpName);
				setClassCode(tmpClassCode);
				setRcSubject(tmpRcSubject);
				setItemIds(tmpItemIds);
				setJson(tmpJson);
				setCategoryTags(tmpCategoryTags);
				setTags(tmpTags);
				setPdfs(tmpPdfs);
				setSyllabusIds(tmpSyllabusIds);
			
				setPdfsLastUpdateTs(tmpPdfsLastUpdateTs);
				setJsonUpdateTs(tmpJsonUpdateTs);
			
				setNameRaw(tmpName);
				setClassCodeRaw(tmpClassCode);
				setRcSubjectRaw(tmpRcSubject);
				setItemIdsRaw(tmpItemIds);
				setJsonRaw(tmpJson);
				setCategoryTagsRaw(tmpCategoryTags);
				setTagsRaw(tmpTags);
				//setPdfsRaw(tmpPdfs);
				setSyllabusIdsRaw(tmpSyllabusIds);
			
			}
		);
				
		getData('item/listCategoryTags', navigate).then(res => setCategoryTagsAllOption(res.data));		
		getData('item/listTags', navigate).then(res => setTagsAllOption(res.data));
		getData('item/listSyllabusItems', navigate).then(res => setSyllabusesAllOption(res.data));
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	let fileDownloadHandler = async () => {
		
		let zip = new JSZip();		
		
		for (let i = 0; i< pdfs.length; i++) {
			const response = await fetch(pdfs[i]);
			await response.blob().then(blob => {
				zip.file(pdfs[i].split("/").pop(), blob)
			});
		}
		zip.generateAsync({type:"blob"}).then(function(content) {
			saveAs(content, itemId);
		});
	}
	
	function isSession1Updatable(){
		return (nameF || classCodeF || rcSubjectF || itemIdsF || categoryTagsF || tagsF|| syllabusIdsF
			|| extraLessonTypeF || writingTitleF || writingInstructionF
			|| (chineseWritingComment.rawCommentId != chineseWritingComment.commentId)
			
			);
	}
	
	
	
	let handleSubmit = async (e) => {
    e.preventDefault();
		if (updateClickedF) {
			return;
		}

		
		
		setUpdateClickedF(true);
    try {
			let obj = {itemId};
			
			if (nameF) {
				obj['name'] = name;
			}
			if (classCodeF) {
				obj['classCode'] = classCode;
			}
			if (rcSubjectF) {
				obj['rcSubject'] = rcSubject;
			}
			
			if (categoryTagsF) {
				obj['categoryTags'] = categoryTags;
			}
			
			if (tagsF) {
				obj['tags'] = tags;
			}
			
			if (itemIdsF) {
				obj['itemIds'] = itemIds;
			}
			
			if (syllabusIdsF) {
				obj['syllabusIds'] = syllabusIds;
			}
			
			if (extraLessonTypeF) {
				obj['extraLessonType'] = extraLessonType;
			}
			
			if (writingTitleF || writingInstructionF) {
				obj['writingTitle'] = writingTitle;
				obj['writingInstruction'] = writingInstruction;
			}
			
			if (chineseWritingComment.rawCommentId !== chineseWritingComment.commentId) {
				obj['commentId'] = chineseWritingComment.commentId
			}
			
			
      await postData("item/updateCourseItem", obj, navigate);
			if (nameF) { setNameF(false); setNameRaw(name); }
			if (classCodeF) { setClassCodeF(false); setClassCodeRaw(classCode);}
			if (rcSubjectF) { setRcSubjectF(false); setRcSubjectRaw(rcSubject);}
			if (extraLessonTypeF) { setExtraLessonTypeF(false); setExtraLessonTypeRaw(extraLessonType);}
			if (itemIdsF) { setItemIdsF(false); setItemIdsRaw(itemIds);}
			if (categoryTagsF) { setCategoryTagsF(false); setCategoryTagsRaw(categoryTags);}
			if (tagsF) { setTagsF(false); setTagsRaw(tags);}
			if (syllabusIdsF) { setSyllabusIdsF(false); setSyllabusIdsRaw(pdfs);}			
			if (writingTitleF || writingInstructionF) { 
				setWritingTitleF(false); setWritingTitleRaw(pdfs);
				setWritingInstructionF(false); setWritingInstructionRaw(pdfs);
			}
			
			if (chineseWritingComment.rawCommentId !== chineseWritingComment.commentId) {
				setChineseWritingComment((prev)=>({...prev, ['rawCommentId']:chineseWritingComment.commentId}))
			}
			
			setUpdateClickedF(false);
			
			setMessage("Update successfully");
    } catch (err) {
      console.log(err);
    }
  };
	
	
	
	const [thumbnailPath, setThumbnailPath] = useState({
		data:"",
		file:null,
		flag:false,		
	});
	
	let uploadThumbnailPath = async (e) => {
    e.preventDefault();
		if (thumbnailPath.flag) {
			return;
		}
		setThumbnailPath((p)=>({...p, flag:true}));
    try {
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("imagefile", thumbnailPath.file);
			
      let res = await postFormData("utility/uploadItemThumbnailPath", data, navigate);
    	
			setThumbnailPath(p=>({data:res.data, flag:false, file:null}));
		
			setMessage("Update successfully");
    } catch (err) {
      console.log(err);
    }
  };
	
	
	
	
	
	
	const [writingPreImage, setWritingPreImage] = useState();
	const [writingPreImageF, setWritingPreImageF] = useState(false);
	
	let uploadWritingPreImage = async (e) => {
    e.preventDefault();
		if (writingPreImageF) {
			return;
		}
		setWritingPreImageF(true);
    try {
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("imagefile", writingPreImage);
			
      let res = await postFormData("utility/uploadWritingPreImage", data, navigate);
    	
			setWritingPreImageF(false); 				
			setWritingPreImage(null);
		
			writingAttachment.push(res.data);
			setMessage("Update successfully");
    } catch (err) {
      console.log(err);
    }
  };
	
	let removeWritingPreImage = async (i)=> {
		//handleShow('deletePreImage')
		
		let obj = {itemId, i};
		await postData("item/removeWritingPreImage", obj, navigate);
		let tmpWritingAttachment = [...writingAttachment];
		tmpWritingAttachment.splice(i, 1)
		setWritingAttachment(tmpWritingAttachment);
	}
	
	
	
	
	//update session 2
	let updateJson = async (e) => {
    e.preventDefault();
		if (updateClickedS2F) {
			return;
		}

		
		
		setUpdateClickedS2F(true);
    try {
			let obj = {itemId, json};
			
			//console.log(obj);
      await postData("item/updateCourseItem", obj, navigate);
			setJsonF(false); 
			setJsonRaw(json);
			setJsonUpdateTs("NOW");
			
			setUpdateClickedS2F(false);
			
			setMessage("Update successfully");
    } catch (err) {
      console.log(err);
    }
  };
	
	
	//update session 3
	const [selectedFile, setSelectedFile] = useState();
	const [selectedFileF, setSelectedFileF] = useState(false);
	const pdfFileHandler = (e) => {
		setSelectedFile(e.target.files[0]);
		setSelectedFileF(true);
	};
	
	let uploadPdf = async (e) => {
    e.preventDefault();
		if (updateClickedS3F) {
			return;
		}
		setUpdateClickedS3F(true);
    try {			
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("pdffile", selectedFile);
			
      let res = await postFormData("utility/uploadPdf", data, navigate);
    	
			setUpdateClickedS3F(false); 
			setPdfs(res.data);			
			setPdfsLastUpdateTs("NOW");					
		
			setMessage("Update successfully");
    } catch (err) {
      console.log(err);
    }
  };
	
	//const [multiSelections, setMultiSelections] = useState([]);
	const [show, setShow] = useState(false);
	const [showType, setShowType] = useState("");
	
	const [newSubitemId, setNewSubitemId] = useState(0);
	
	
  const handleClose = () => {
		setShow(false);
		if (showType === 'itemIds') {

			if (newSubitemId !== 0) {
				setItemIds([...itemIds, newSubitemId]);
				setNewSubitemId(0);
				setItemIdsF(true);
			}
		}
	};
	
	
	const handleShow = (t) => {
		setShowType(t);
		setShow(true)
	};
	
	
	
	const [imgState, setImgState] = useState({
		clickImg: '',
		showImg: false,
	});
	
	
	const loadWritingRequirement = () => {
		if (!imgState.clickImg) {
			return;
		}
		let targetLink = imgState.clickImg;
		let obj = {itemId, targetLink};
		
		postData("item/setWritingImg", obj, navigate);
		
		writingAttachment.push({name:"name", "imageUrl":targetLink});
		setImgState(p=>({...p, ['showImg']:false, ['clickImg']:""}))
	}
	
	return (
	<div className="billContainer">
		<div>	
					
				<Image className={"modalContentWrapper " + (imgState.showImg ? "show": "hide")} fluid
					src={imgState.clickImg}
					rounded />
					
					{(imgState.showImg && extraLessonTypeRaw === 'WRITING' && extraLessonType === 'WRITING') && (
					<div className="modalButton">
						<RedButton isEnabled={true} clickedAction={()=>loadWritingRequirement()} bText={"Load to writing Requirement"} />
					</div>)}	
					
				<div className={"modalBackdrop " + (imgState.showImg ? "show" : "hide")} onClick={()=>{ setImgState(p=>({...p, ['showImg']:false, ['clickImg']:""}))}}/>
			</div>
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
		<Form>
			{/* ---------------------- modal ---------------------- */}
			<Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
					{
						(showType === 'categoryTags') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="categoryTagsOption"
							multiple
							onChange={(d) => {
								setCategoryTags(d);
								if (categoryTagsRaw.length === d.length && intersection(categoryTagsRaw, d).length === categoryTagsRaw.length) {
									setCategoryTagsF(false);
								} else {
									setCategoryTagsF(true);
								}
							}}
							options={categoryTagsAllOption}
							placeholder="Choose category tags..."
							selected={categoryTags}
					/>)
					}
					{(showType === 'tags') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="tagsOption"
							multiple
							onChange={(d) => {
								setTags(d);
								if (tagsRaw.length === d.length && intersection(tagsRaw, d).length === tagsRaw.length) {
									setTagsF(false);
								} else {
									setTagsF(true);
								}
							}}
							options={tagsAllOption}
							placeholder="Choose tag..."
							selected={tags}
						/>)
					}
					{(showType === 'syllabusIds') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey={(s) => `${s.id} - (${s.level})${s.name_en}`}
							multiple
							onChange={(d) => {
								let dm = d.reduce((p, c) => {
									return [...p, c.id];
								}, [])

								setSyllabusIds(dm);
								if (syllabusIdsRaw.length === dm.length && intersection(syllabusIdsRaw, dm).length === syllabusIdsRaw.length) {
									setSyllabusIdsF(false);
								} else {
									setSyllabusIdsF(true);
								}
							}}
							options={syllabusesAllOption}
							placeholder="Choose syllabus..."
							filterBy={["id"]}
							selected={syllabusesAllOption.filter(x => {return ( syllabusIds.some(s => s === x.id) );})}
						/>)
					}
					{(showType === 'itemIds') && (<Form.Control type="number" min="1" placeholder="Enter id" onChange={
						(e)=> {
							setNewSubitemId(e.target.value);
						}
					} />
					)
					}
				</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
		
		
			{/* ---------------------- Top ---------------------- */}
		
			<div className="message">{message ? <p>{message}</p> : null}</div>
			<Form.Group as={Row}  className="mb-3">
				<Col sm={"auto"}>
					<h2> {"Item id : " + itemId} </h2>
				</Col>
			</Form.Group>
			
			
			{/* ---------------------- session 1 ---------------------- */}
			
			<Form.Group className="rcorners2" style={{padding:"10px 20px 0px 20px", background:"white", borderRadius:"15px 15px 0 0", border:"2px solid #73AD21"}}>
			
				<Form.Group as={Row} className="mb-3" controlId="formName"  style={{paddingBottom:"5px", borderBottom:"2px solid #73AD21"}}>
					<Col sm="1">
						<Image className="thumbnail-path" fluid
							src={`${thumbnailPath.data}`}
							rounded onClick={()=> window.open(thumbnailPath.data, "_blank")} />
					</Col>
					<Col sm={"auto"}>
						<Button variant={!thumbnailPath.file ? "secondary": "primary"} type="submit" onClick={uploadThumbnailPath} disabled={!thumbnailPath.file}>
							Upload 
						</Button>
					</Col>
					<Col sm="4">
						<div>
							<input type="file" className="form-control" onChange={(e) => setThumbnailPath(p=> ({...p, file:e.target.files[0]}))}  />
						</div>
					</Col>
				</Form.Group>
			
			
				<Form.Group as={Row} className="mb-3" controlId="formName">
					<Form.Label column sm={1}>Name</Form.Label>
					<Col sm={12}>
						<Form.Control type="text" value={name} 
							onChange={
								e => { 
									setName(e.target.value); 
									if (nameRaw === e.target.value) { 
										setNameF(false) 
									} else { 
										setNameF(true);
									}
								}
							} 
						/>
					</Col>
				</Form.Group>
				
				
			
				<Form.Group as={Row} className="mb-3" controlId="formRcSubject">
					<Form.Label column sm={1}>Subject</Form.Label>
					
					<Col sm={3}>
						<Form.Select value={rcSubject} 
							onChange={
								e => { 
									setRcSubject(e.target.value); 
									
									if (rcSubjectRaw === e.target.value) { 
										setRcSubjectF(false) 
									} else { 
										setRcSubjectF(true);
									}
								} 
							} 
						>
							<option value="english">English</option>
							<option value="chinese">Chinese</option>
							<option value="math">Maths</option>
						</Form.Select>
					</Col>
					<Form.Label column sm={2}>Class Code</Form.Label>
					<Col sm={6}>
						<Form.Control type="text" value={classCode} 
							onChange={
								e => { 
									setClassCode(e.target.value); 
									if (classCodeRaw === e.target.value) { 
										setClassCodeF(false) 
									} else { 
										setClassCodeF(true);
									}
								} 
							} 
						/>
					</Col>
				</Form.Group>
				<Form.Group as={Row} className="mb-3" controlId="formSelection">
				
				
						<Form.Group as={Col} sm={6} className="mb-3">
							<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
								<Form.Label as={Col}>Category Tags</Form.Label>
								<Row style={{width: "100%", paddingLeft: "0px"}}>
									{ (categoryTags != null && categoryTags.length > 0) ? categoryTags.map(ct => (
											<Col key={ct} sm={"auto"}>
												<span className="rectTag">{ct}</span>
											</Col>
										)
										): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
									}
									<Col sm={"auto"}>
										<span className="rectTag"
												style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => handleShow('categoryTags')}
											>
											Edit
										</span>
									</Col>
									<Col sm={"auto"}>
										<span className="rectTag"
													style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => {
												setCategoryTags(categoryTagsRaw);
												setCategoryTagsF(false);
											}}
											>
											Reset
										</span>
									</Col>
									
									
								</Row>
							</Row>
						</Form.Group>

						<Form.Group as={Col} sm={6} className="mb-3" controlId="formCategoryTags" >
							<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
								<Form.Label as={Col}>Level Tags</Form.Label>
								
								<Row style={{width: "100%", paddingLeft: "0px"}}>
									{ (tags != null && tags.length > 0) ? tags.map(ct => (
											<Col key={ct} sm={"auto"}>
												<span className="rectTag">{ct}</span>
											</Col>
										)
										): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
									}
									<Col sm={"auto"}>
										<span className="rectTag" 
											style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => handleShow('tags')}
											>
											Edit
										</span>
									</Col>
									<Col sm={"auto"}>
										<span className="rectTag"
													style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => {
												setTags(tagsRaw);
												setTagsF(false);
											}}
											>
											Reset
										</span>
									</Col>
								</Row>
							</Row>
						</Form.Group>
						<Form.Group as={Col} sm={6} className="mb-3" controlId="formSyllabusIds">
							<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
								<Form.Label as={Col}>Syllabus</Form.Label>						
								<Row style={{width: "100%", paddingLeft: "0px"}}>
									{ (syllabusIds != null && syllabusIds.length > 0) ? syllabusIds.map(ct => (
											<Col key={ct} sm={"auto"}>
												<span className="rectTag">{ct}</span>
											</Col>
										)
										): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
									}
									<Col sm={"auto"}>
										<span className="rectTag" 
											style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => handleShow('syllabusIds')}
											>
											Edit
										</span>
									</Col>
									<Col sm={"auto"}>
										<span className="rectTag"
											style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => {
												setSyllabusIds(syllabusIdsRaw);
												setSyllabusIdsF(false);
											}}
											>
											Reset
										</span>
									</Col>
								</Row>
							</Row>
						</Form.Group>
						<Form.Group as={Col} sm={6}  className="mb-3" controlId="formItemIds">
							<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
								<Form.Label as={Col}>Subitems</Form.Label>
								<Row style={{width: "100%", paddingLeft: "0px"}}>
									{
										(itemIds != null && itemIds.length > 0) ? itemIds.map(ct => (
											<Col key={ct} sm={"auto"}>
												<span className="rectTag">{ct}</span>
											</Col>
											)
										) :
										<Col sm={"auto"}><span>{"Nothing!"}</span></Col>
									}
									<Col sm={"auto"}>
										<span className="rectTag" 
											style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => handleShow('itemIds')}
											>
											Add
										</span>
									</Col>
									<Col sm={"auto"}>
										<span className="rectTag" 
													style={{backgroundColor: "white", color:"#2EA44F"}}
											onClick={() => {
												setItemIds(itemIdsRaw);
												setItemIdsF(false);
											}}
											>
											Reset
										</span>
									</Col>
								</Row>
							</Row>
						</Form.Group>
						
						
						<Form.Group as={Row} className="mb-3">
							<Form.Label column sm={1}>Lesson Type</Form.Label>
							
							<Col sm={2}>
								<Form.Select value={extraLessonType} 
									onChange={
										e => { 
											setExtraLessonType(e.target.value); 
											
											if (extraLessonTypeRaw === e.target.value) { 
												setExtraLessonTypeF(false) 
											} else { 
												setExtraLessonTypeF(true);
											}
										} 
									} 
								>
									<option value="PDF">PDF</option>
									<option value="WRITING">WRITING</option>
								</Form.Select>
							</Col>					
						
						
						
						{
							(extraLessonType === 'WRITING') && (
								<>
									<Form.Label column sm={1}>(W)Title</Form.Label>
									
									<Col sm={2}>
										<Form.Control type="text" value={writingTitle} 
											onChange={
												e => { 
													setWritingTitle(e.target.value); 
													if (writingTitleRaw === e.target.value) { 
														setWritingTitleF(false) 
													} else { 
														setWritingTitleF(true);
													}
												}
											} 
										/>
									</Col>
									
									<Form.Label column sm={1}>(W)Instruction</Form.Label>
									
									<Col sm={2}>
										<Form.Control type="text" value={writingInstruction} 
											onChange={
												e => { 
													setWritingInstruction(e.target.value); 
													if (writingInstructionRaw === e.target.value) { 
														setWritingInstructionF(false) 
													} else { 
														setWritingInstructionF(true);
													}
												}
											} 
										/>
									</Col>
									
									
								</>
							)	
						}
						
						{((extraLessonType === 'WRITING' && rcSubject === 'chinese'))	&& (
							<>
								<Form.Label column sm={2}>(W)Comment ID</Form.Label>
									
								<Col sm={1}>
									<Form.Select value={chineseWritingComment.commentId} onChange={(e)=>{
											setChineseWritingComment((prev)=>({...prev, ['commentId']:e.target.value}))
											}}>
											{allChineseWritingComments.map((o) => {
												return (
													<option value={o.id}>{o.name}</option>
												)
											})}
									</Form.Select>
								</Col>
							</>
							)
						}
						</Form.Group>	
						{
							(extraLessonTypeRaw === 'WRITING' && extraLessonType === 'WRITING') && (
								
								<Row style={{marginBottom:"20px"}}>
									<Col sm={"auto"}>
										<Button variant={!writingPreImage ? "secondary": "primary"} type="submit" onClick={uploadWritingPreImage} disabled={!writingPreImage}>
											Upload 
										</Button>
									</Col>
									<Col>
										<div>
											<input type="file" className="form-control" onChange={(e) => setWritingPreImage(e.target.files[0])}  />
										</div>
									</Col>
								</Row>
							)
						}
						{
							(extraLessonTypeRaw === 'WRITING' && extraLessonType === 'WRITING') && 
							writingAttachment.map((imgLink, i)=>{return (
								<>
									<Col key={i} sm={2} style={{padding:"2px",position:"relative"}}>
										<Image fluid
											key={Date.now()}
											src={`${imgLink.imageUrl}`}
											rounded onClick={()=> window.open(imgLink.imageUrl, "_blank")} />
											
										<button key={i} className="cross-btn" onClick={(e) => {e.preventDefault(); removeWritingPreImage(i);}}>X</button>
									</Col>
									
								</>
							
							)})
						}
						
						
						
					</Form.Group>
				</Form.Group>
      <Form.Group>
				<Form.Group style={{marginTop:"-2px", padding:"10px 20px 10px 20px", borderRadius:"0 0 15px 15px", border:"2px solid #73AD21"}}>
					<Col>
					<Button
						variant={!isSession1Updatable() ? "secondary": "primary"}  
						disabled={!isSession1Updatable()} 
						type="submit" 
						onClick={handleSubmit}>
								Update
							</Button>
					</Col>
				</Form.Group>
      </Form.Group>
			
			
			{/* ---------------------- session 2 ---------------------- */}
			
      <Form.Group className="mb-3" controlId="formJson"  style={{margin:"20px 0 0 0", padding:"10px 20px 20px 20px", borderRadius:"15px", border:"2px solid #73AD21"}}>
				<Row>
        <Form.Label as={Col} sm={5}>Encoded PDF (last update: {jsonUpdateTs})
					<div style={{float:"left"}}>
						{/*<span>{<span>{'Go to '}</span>*/}
						<a href={"https://ehla-class.com/item/" + itemId} target="_blank" rel="noreferrer">Check Encoded</a>							
						{/*<span>{' to get encoded PDF'}&nbsp;&nbsp;&nbsp;</span>*/}
						<span>&nbsp;&nbsp;&nbsp;</span>
					</div></Form.Label>
				<Form.Label as={Col} sm={7} style={{paddingRight:'0'}}>
					<div style={{float:"right"}}>
						{/*<span>{<span>{'Go to '}</span>*/}
						<a href="https://material-upload.ehlacademy.org/split-image-master" target="_blank" rel="noreferrer">{'https://material-upload.ehlacademy.org/split-image-master'}</a>
							
						{/*<span>{' to get encoded PDF'}&nbsp;&nbsp;&nbsp;</span>*/}
						<span>&nbsp;&nbsp;&nbsp;</span>
					</div>
				</Form.Label>
				</Row>
        <Form.Control value={json} onChange={e => { 
					setJson(e.target.value); 
					
					if (jsonRaw === e.target.value) { 
						setJsonF(false) 
					} else { 
						setJsonF(true);
					}
				}}/>
				
				<Col style={{marginTop:"10px"}}>					
					<Button variant={!jsonF ? "secondary": "primary"}  disabled={!jsonF} type="submit" onClick={updateJson}>
						Update
					</Button>					
				</Col>


				
			</Form.Group>
				
			{/* ---------------------- session 3 ---------------------- */}
			<div id='container-s3'>
				<div id={updateClickedS3F ? 'container-loader-s3' : 'container-loader-s3-disabled'}>
					<ClipLoader
						className='cliploader'
						loading={updateClickedS3F}
						size={50}
						aria-label="Loading Spinner"
						data-testid="loader"
					/>
				</div>
				<Form.Group className="mb-3" controlId="formPdfs" style={{margin:"20px 0 ", padding:"10px 20px 0px 20px", borderRadius:"15px 15px 0 0", border:"2px solid #73AD21"}}>
				
					<Row>
						<Form.Label as={Col} sm={4}>PDF Images (last update: {pdfsLastUpdateTs})</Form.Label>{' '}
						<Form.Label as={Col} sm={8}>
							<div style={{float:"right"}}>
								<span className="downloadBtn" type='button' onClick={()=>fileDownloadHandler()}><i className="fa fa-download"></i>Download Pictures</span>
							</div>
						</Form.Label>
					</Row>
					<Row style={{marginBottom:"20px"}}>
						<Col sm={"auto"}>
							<Button variant={!selectedFileF ? "secondary": "primary"} type="submit" onClick={uploadPdf} disabled={!selectedFileF}>
								Upload 
							</Button>
						</Col>
						<Col>
							<div>
								<input type="file" className="form-control" onChange={pdfFileHandler}  />
							</div>
						</Col>
					</Row>
					
				</Form.Group>
				<Form.Group style={{marginTop:"-18px", padding:"10px 20px 10px 20px", borderRadius:"0 0 15px 15px", border:"2px solid #73AD21"}}>
					{/*<Container className="bg-primary">*/}
					<Row>
						{pdfs.map((pdfLink, i) => {
								let cSize = 3;
								if (i >= 4) {
									cSize = 1
								}	
								return (
									<Col key={i} sm={cSize} style={{padding:"2px"}}>
										<Image fluid
											key={"image"+i}
											src={`${pdfLink}?${Date.now()}`}
											rounded onClick={()=> {
												setImgState(p=>({...p, ['showImg']:true, ['clickImg']:`${pdfLink}?${Date.now()}`}));
											}} />
									</Col>
								);
							}
						)}
					</Row>
				</Form.Group>
			</div>
    </Form>
		
		<div>
			<ItemHomework itemId={itemId}/>
		
		</div>
		
		</div>
  );
}